import { BooleanParam, useQueryParam } from 'use-query-params'

export const useShowInactiveQueryParam = () =>
  useQueryParam('showInactive', BooleanParam)
